import React from "react";
import { Route, Switch, withRouter, Link } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Divider from '@material-ui/core/Divider';
import MenuList from '@material-ui/core/MenuList';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import dplogo from './assets/dp_logo.png'
import dpbackground from './assets/dpbackground.jpg';
import TextField from '@material-ui/core/TextField';
import HeaderRight from './components/HeaderRight';
import Typography from '@material-ui/core/Typography';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { IconButton } from "@material-ui/core";
import Hidden from '@material-ui/core/Hidden';

import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExitIcon from '@material-ui/icons/ExitToApp';
import FaceIcon from '@material-ui/icons/PermIdentity';
import SettingsIcon from '@material-ui/icons/Settings';
import HistoryIcon from '@material-ui/icons/History';
import TodayIcon from '@material-ui/icons/Today';
import SearchIcon from '@material-ui/icons/Search';

import red from '@material-ui/core/colors/red';

import io from 'socket.io-client';

import Install from "./pages/install";
import HomePage from "./pages/homepage";
import ForgotPassword from "./pages/forgotpassword";
import Patient from "./pages/patient";
import Admin from "./pages/admin";
import AdminStaff from './pages/admin/staffedit';
import PatientSearchResults from './pages/patient/searchresults';
import SVGTest from './pages/svgtest';
import ApptBook from './pages/apptbook';

import toRenderProps from 'recompose/toRenderProps';
import withState from 'recompose/withState';
import Menu from '@material-ui/core/Menu';

import ls from 'local-storage';
import Tooltip from '@material-ui/core/Tooltip';

import versioninfo from './metadata.json';


const drawerWidth = 72;

const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#005EB8', // #005EB8
    },
    secondary: red,
  },
});

const WithState = toRenderProps(withState('anchorEl', 'updateAnchorEl', null));

const styles = theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    //paddingRight: 24, // keep right padding when drawer closed
    marginLeft: drawerWidth+8,
    //minHeight: 75,
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),  
    boxShadow: 'none',
  },
  appBarShift: {
    width: drawerWidth,
    /*width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),*/
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  icon: {
    margin: theme.spacing.unit * 2,
  },
  dplogodiv: {
    minHeight: 64,
    background: '#002140',
  },
  dplogo: {
    width: 60,
    marginTop: 8,
    marginLeft: 4,
  },
  drawer: {
    zIndex: theme.zIndex.drawer + 1,
    width: drawerWidth,
    minWidth: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    backgroundColor: '#005EB8',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: 0,
    marginTop: 64,
    height: `calc(100vh - 64px)`,
    overflow: 'auto',
  },
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
  menuItem: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& $primary, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
  gridItem: {
    
  },
  searchText: {
    verticalAlign: 'middle',
  },
  mainIcon: {
    fontSize: 38,
    color: 'white',
  },
  exitDivider: {
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
  }
  
});

class App extends React.Component {
  constructor(props) {
    super(props);
    
    //console.log(window.location.hostname);
    var cacheduuid=undefined;
    this.state.searches = [];

    if(ls.get("authenticator")){
        cacheduuid=ls.get("authenticator");
    }
    
    if(process.env.NODE_ENV==="development"){
      this.socket = io('http://'+window.location.hostname+':7001',{query:"uuid="+cacheduuid});
      //this.setState({authenticated:true});
      //this.state.authenticated=true;
     // this.state.authenticator="test";
    }else{
        this.socket = io('https://'+window.location.hostname+':7000',{secure:true,query:"uuid="+cacheduuid });
    }
    if(ls.get("authenticator")){
        this.socket.on("connect",(d)=>{
            this.setState({authenticated:true,authenticator:ls.get("authenticator")});
            this.state.initials=ls.get("initials");
            this.state.authenticated=true;
            this.state.authenticator=ls.get("authenticator");
        });
        
    }
  }

  state = {
    open: false,
    searchfor: "",
    currentpatient: "",
    refreshPatientDetails: false,
    initials:'',
    logoutDialogOpen: false,
    //authenticated:true,
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  initiateSearch = (searchstring) => {
    if (searchstring.substring(0, 1) === '#')
    {
      // load the patient id directly
      this.props.history.push('/patient/'+searchstring.substring(1));
      this.setState({searchfor: searchstring});
      this.socket.emit("patient_search",{search:searchstring,authenticator:this.state.authenticator});
    }
    else
    {
      this.props.history.push('/patient/search/'+searchstring);
      this.setState({searchfor: searchstring});
      this.socket.emit("patient_search",{search:searchstring,authenticator:this.state.authenticator});
      //this.searches.push(event.target.value);
    }
  }

  handleSearch = (event) => {
    if(event.keyCode === 13)
    {
      let searchstring = event.target.value;

      this.initiateSearch(searchstring);
    }
  };  

  handleSearchButton = (event) => {
    //window.location = '/patient/search/'+searchText.value;
    this.initiateSearch(this.state.searchfor);
  };

  searchboxLoaded=(event)=>{
    if(this.props.location.pathname.split('/search/').length>1 && this.props.location.pathname.includes("/patient/search")){
        var searchvalue=this.props.location.pathname.split('/search/')[1];
        if(searchvalue.length>0){
            this.props.history.push('/patient/search/'+searchvalue);
            this.setState({searchfor: searchvalue});
            this.socket.emit("patient_search",{search:searchvalue,authenticator:this.state.authenticator});
            
        }
    }
  }

  componentDidMount(){
    
    console.log("Client version: 4.1."+versioninfo.build);
    this.searchboxLoaded();
    if(!this.currentpatient){
        this.setState({currentPatientSecondLine:"No patient loaded"});
    }
    this.socket.on("disconnect",(data)=>{
        /*this.setState({authenticator:"",authenticated:false});
        ls.remove("authenticator");
        ls.remove("initials");
        ls.remove("practice");
        ls.remove("username");*/
    });
    this.socket.on("access_denied_logout",(data)=>{
        this.setState({authenticator:""});
        this.setState({authenticated:false});
    });
    this.socket.on("logout_success",(data)=>{        
        this.props.history.push("/");
        this.setState({authenticator:"",authenticated:false});
        ls.remove("authenticator");
        ls.remove("initials");
        ls.remove("practice");
        ls.remove("username");
    });
    this.socket.on("broadcast_message",(data)=>{        

    });
  };

  handleClickedMenu = (v)=> (e) => {
    this.setState({currentpatient: v});
    this.props.history.push('/patient/'+v);
    //this.socket.emit("patient_details",v);
  };

  handleFocus = (e) => {
      e.target.select();
  }

  logoClicked = e =>{
      this.props.history.push("/");
  }

  doExit = e => {
    this.setState({logoutDialogOpen: true});
  }

  logoutYes = e => {
    console.log("logout");
    this.socket.emit("user_logout",{authenticator:ls.get("authenticator")});
    this.setState({logoutDialogOpen: false});
  }

  logoutNo = e => {
    this.setState({logoutDialogOpen: false});
  }

  render() {
    const { classes } = this.props;
    const { searchfor } = this.state;
    
    return (
    <MuiThemeProvider theme={theme}>
        <Dialog
            open={this.state.logoutDialogOpen}
            onClose={this.logoutNo}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">{"Log out"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                Are you sure you want to log out?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={this.logoutNo} color="primary">
                No
                </Button>
                <Button onClick={this.logoutYes} color="primary" autoFocus>
                Yes
                </Button>
            </DialogActions>
        </Dialog>    
      <Switch>
        <div className={classes.root}>
          <CssBaseline />
          {this.state.authenticated ?
          <>
          <AppBar position="absolute" color="default"
            className={classNames(classes.appBar, this.state.open && classes.appBarShift)}
          >
          <Toolbar disableGutters={!this.state.open} className={classes.toolbar}>                     
                    <Typography color="inherit" style={{ borderRight: '0.1em solid #EAEAEA', padding: '6px', height: '68px' }}> 
                        <TextField
                            id="searchText"
                            value={searchfor} className={classes.searchText} placeholder="Search for a patient"
                            onChange={(e) => this.setState({ searchfor:e.target.value})} onKeyDown={this.handleSearch}
                            onFocus={this.handleFocus}
                        />
                        <IconButton onClick={this.handleSearchButton} className={classes.button} aria-label="Search">
                        <SearchIcon/>
                        </IconButton>
                        {/*<IconButton onClick={this.handleAdvSearch} className={classes.button} aria-label="Advanced Search">
                        <MenuIcon/>
                        </IconButton>*/}

                        <WithState>
                        {({ anchorEl, updateAnchorEl }) => {
                            const open = Boolean(anchorEl);

                            const handleClickedMenu = (v)=> (e) => {
                                handleClose();
                                this.props.history.push('/patient/'+v);
                            };
                            const handleClose = () => {
                                updateAnchorEl(null);
                            };

                            return (
                            <React.Fragment>
                                <IconButton className={classes.button} aria-label="History"
                                aria-owns={open ? 'render-props-menu' : undefined}
                                aria-haspopup="true"
                                onClick={event => {
                                    if(this.state.searches.length>0){
                                        updateAnchorEl(event.currentTarget);
                                    }
                                }} >
                                <HistoryIcon />
                                </IconButton>
                                <Menu id="render-props-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
                                    {this.state.searches.map((search, index) =>

                                        <MenuItem onClick={handleClickedMenu(search.id)} key="faceicon">
                                                <ListItemIcon>
                                                    <FaceIcon /> 
                                                </ListItemIcon>
                                            {search.name}
                                        </MenuItem>
                                    )}
                                </Menu>
                            </React.Fragment>
                            );
                        }}
                        </WithState>
                    </Typography>
                
                <Hidden only="xs">
                    <Typography color="inherit" style={{ borderRight: '0.1em solid #EAEAEA', padding: '6px', height: '68px', lineHeight: '1.25' }}> 
                        <b>{this.state.currentPatientNameText}</b><br/>
                        <label style={{fontSize:"9pt",lineHeight:"8pt"}}>{this.state.currentPatientSecondLine}
                        <br />{this.state.currentPatientThirdLine}</label>
                    </Typography>
                </Hidden> 
                   
                <Hidden only={['xs']}>
                    <HeaderRight initials={this.state.initials} /> 
                </Hidden>
          </Toolbar>          
          </AppBar>
          <Drawer
            variant="permanent"
            classes={{
              paper: classes.drawerPaper
            }}
            open={this.state.open}
          >
            <div className={classes.dplogodiv}>
              <img src={dplogo} style={{cursor:"pointer"}} onClick={this.logoClicked} alt="DentalPlus Logo" className={classes.dplogo}/>
            </div>
            <Divider />
            <MenuList>
              <Tooltip title="Patient" placement="right">
                <MenuItem button component={Link} to={"/patient/"+this.state.currentpatient} className={classes.menuItem}>
                    <ListItemIcon>
                    <FaceIcon className={classes.mainIcon}/>
                    </ListItemIcon>
                    <ListItemText classes={{ primary: classes.primary }} inset />
                </MenuItem>
              </Tooltip>
              
              {/*<Tooltip title="Appointment Book" placement="right">
                <MenuItem button component={Link} to={"/apptbook"} className={classes.menuItem}>
                    <ListItemIcon>
                    <TodayIcon className={classes.mainIcon}/>
                    </ListItemIcon>
                    <ListItemText classes={{ primary: classes.primary }} inset />
                </MenuItem>
              </Tooltip>*/}
            
              <Tooltip title="Admin" placement="right">
                <MenuItem button component={Link} to="/admin">
                    <ListItemIcon>
                    <SettingsIcon className={classes.mainIcon} style={{fontSize: 38}}/>
                    </ListItemIcon>        
                    <ListItemText classes={{ primary: classes.primary }} inset />
                </MenuItem>
              </Tooltip>
              <Divider light={true} className={classes.exitDivider}/>
              <Tooltip title="Log out" placement="right">
              <MenuItem button onClick={this.doExit}>
                <ListItemIcon>
                  <ExitIcon className={classes.mainIcon} style={{fontSize: 38}}/>
                </ListItemIcon>        
                <ListItemText classes={{ primary: classes.primary }} inset />
              </MenuItem>
              </Tooltip>
            </MenuList>
          </Drawer>
          
          <main className={classes.content}>
            <Route exact path="/" render={(props)=><Admin {...props} socket={this.socket} authenticator={this.state.authenticator}/>} />
            <Route exact path="/patient/" render={(props)=><Patient {...props} socket={this.socket} history={this.props.history} />} /> 
            <Route exact path="/patient/:patient_id" render={(props)=><Patient {...props} parentstate={this} socket={this.socket} history={this.props.history} />} /> 
            <Route path="/patient/search/:searchstring" render={(props)=><PatientSearchResults {...props} parentstate={this} socket={this.socket} />} /> 
            <Route exact path="/apptbook" render={(props)=><ApptBook {...props} socket={this.socket} authenticator={this.state.authenticator} />} />            
            <Route exact path="/admin" render={(props)=><Admin {...props} socket={this.socket} authenticator={this.state.authenticator} />} />            
            <Route path="/admin/staffedit/:staffid" render={(props)=><AdminStaff {...props} socket={this.socket} />} />
            <Route exact path="/admin/staffedit/" render={(props)=><AdminStaff {...props} socket={this.socket} />} /> 
          </main>
          </>
          :<main className={classes.content} style={{height:"100vh",marginTop:"0",backgroundImage:"url("+dpbackground+")",backgroundRepeat:"no-repeat",backgroundAttachment:"fixed"}}>
          <Switch>
            <Route path="/svgtest" exact render={(props)=><SVGTest {...props} parent={this} />} />
            <Route path="/install" exact render={(props)=><Install {...props} socket={this.socket} history={this.props.history} parent={this} />} />
            <Route path="/forgotpassword" exact render={(props)=><ForgotPassword {...props} socket={this.socket} history={this.props.history} parent={this} />} />
            <Route path="/forgotpassword/:auth" render={(props)=><ForgotPassword {...props} socket={this.socket} history={this.props.history} parent={this} />} />
            <Route path="*" render={(props)=><HomePage {...props} socket={this.socket} parent={this} history={this.props.history} />} />
          </Switch>
          </main>}
        </div>
      </Switch>
    </MuiThemeProvider>
    );
  }
}

export default withRouter(withStyles(styles)(App));